import { useGetMargin } from "~/v2/api/hooks";
import { POSITIONS_POLLING_INTERVAL } from "~/v2/constants";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { useGetPositions } from "~/v3-poc/hooks/useGetPositions";
import { useHeaderPortfolioMetricsController } from "./HeaderPortfolioMetrics.controller";
import { HeaderPortfolioMetricsPresentation } from "./HeaderPortfolioMetrics.pres";

export const HeaderPortfolioMetrics = () => {
  const { currentAccount, product } = useAccountContext();
  const isAccountReady = Boolean(currentAccount?.id && product);
  const {
    positions,
    isLoading: isPositionsLoading,
    isError: isPositionsError,
  } = useGetPositions({
    accountID: currentAccount?.id,
    product,
    options: {
      enabled: isAccountReady,
      refetchInterval: POSITIONS_POLLING_INTERVAL,
    },
  });
  const { margin, isLoading: isMarginLoading } = useGetMargin({
    accountID: currentAccount?.id,
    paper: product === "paper",
    options: { enabled: isAccountReady },
  });

  const { totals } = useHeaderPortfolioMetricsController({
    positions,
    margin,
    isAccountReady,
    isPositionsError,
  });

  return (
    <HeaderPortfolioMetricsPresentation
      totals={totals}
      isLoading={isAccountReady && (isPositionsLoading || isMarginLoading)}
    />
  );
};
